// @owners { team: patients }

/** Must match postMessage strings in the embedded scroll script below. */
export const SCROLLED_TO_BOTTOM = 'scrolled_to_bottom';

/**
 * Applies styles and JavaScript behavior so patient can confirm coupon eligibility
 *
 * IMPORTANT! This method provides Javascript behavior to pass messages to the client so that
 * patients can accept coupon terms and conditions. Altering or removing the script tag
 * will break that behavior.
 * @param htmlContent
 * @returns html string
 */
export const wrapHtmlContent = (htmlContent: string) => {
  const content = htmlContent || '';
  return `<!DOCTYPE html>
  <html>
    <head>
      <title>Terms and Conditions</title>
      <meta http-equiv="content-type" content="text/html; charset=utf-8">
      <meta name="viewport" content="width=device-width, user-scalable=no">
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
      <style type="text/css">
        html, body {
          margin: 0;
          padding: 0;
          min-height: 0;
          height: auto;
        }
        body {
          font-family: Inter, sans-serif;
          font-size: 14px;
          color: #404A52;
          display: flex;
        }
        #terms-content {
          flex: 0 0 auto;
          width: 100%;
        }
      </style>
    </head>
    <body>
      <div id="terms-content">${content}</div>
    </body>
    <script>
      const isNative = typeof window.ReactNativeWebView !== 'undefined';
      let hasReachedBottom = false;

      function postScrolledToBottomIfAtEnd() {
        if (hasReachedBottom) {
          return;
        }
        const scrollTop = isNative ? document.documentElement.scrollTop : window.scrollY;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const isAtBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 20;
        if (isAtBottom) {
          hasReachedBottom = true;
          if (isNative) {
            window.ReactNativeWebView.postMessage('${SCROLLED_TO_BOTTOM}');
          } else {
            window.parent.postMessage('${SCROLLED_TO_BOTTOM}');
          }
        }
      }

      postScrolledToBottomIfAtEnd();

      document.addEventListener('scroll', () => {
        postScrolledToBottomIfAtEnd();
      });

      function sendContentHeight() {
        var contentEl = document.getElementById('terms-content');
        if (!contentEl) return;
        var h = Math.ceil(contentEl.offsetHeight);
        var docEl = document.documentElement;
        var fits = h <= docEl.clientHeight;
        if (fits) {
          docEl.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        }
        var msg = JSON.stringify({ type: 'content_height', height: h });
        if (isNative) {
          window.ReactNativeWebView.postMessage(msg);
        } else {
          window.parent.postMessage(msg);
        }
        postScrolledToBottomIfAtEnd();
      }
      sendContentHeight();
      setTimeout(sendContentHeight, 400);
      window.addEventListener('resize', () => {
        postScrolledToBottomIfAtEnd();
      });
    </script>
  </html>
`;
};
